/// <reference path="../../app.ts" />
/// <reference path="../subcataccordion.ts" />
/// <reference path="../isubcataccordion.ts" />
module Cfnc
{
    "use strict";

    export class AdmissPolicies extends SubCatAccordion implements IsubCatAccordion
    {
        toolTipHeader: string = "What admissions policies are important to you?";

        typeCbs = [{ type: "Early action", isChecked: false },
            { type: "Early Decision", isChecked: false },
            { type: "Deferred admission", isChecked: false },
            { type: "Concurrent enrollment for high school", isChecked: false }];

        public getSelectedTypes(): Array<string>
        {
            var selectedTypes = new Array<string>();
            this.selected = false;
            for ( var i in this.typeCbs )
            {
                if ( this.typeCbs[i].isChecked )
                {
                    selectedTypes.push( this.typeCbs[i].type );
                    this.selected = true;
                }
            }
            return selectedTypes;
        }
    }
}